import { DatabaseServiceInstance } from '@/database'
import { AxiosCallPost } from './apicall'
import { LastInfoStore, LastErrorStore, AuthStore } from '@/stores'

/**
 * Service to access Lynx API authentication.
 */
export default class AuthService {
  /**
   * Constructor.
   * @param {string} baseUrl Base url to connect to lynx API. typically http or https//[ip]/lynxapi
   */
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  }

  /**
   * Encode the password. Typically base64.
   * @param {string} password Non encoded password
   * @returns encoded password. Null if param is null.
   */
  encodePassword (password) {
    if (password === null) {
      return null
    }
    return btoa(password)
  }

  /**
   * Decode the password. Typically base64.
   * @param {string} password Encoded password
   * @returns Non encoded password. Null if param is null.
   */
  decodePassword (encodedpassword) {
    if (encodedpassword === null) {
      return null
    }
    return atob(encodedpassword)
  }

  /**
   * Store the login and password, to be reused later.
   * @param {string} login Login
   * @param {string} password Non encrypted password
   */
  async storeCredentials (login, password) {
    const encoded = this.encodePassword(password)
    await DatabaseServiceInstance.saveLoginAndPassword(login, encoded)
  }

  /**
   * Retrieve last used credentials.
   * @returns Structure with login and password properties.
   */
  async retrieveCredentials () {
    const found = await DatabaseServiceInstance.getLoginAndPassword()
    if (found) {
      if (found.encodedpassword && found.encodedpassword !== '') {
        const decoded = this.decodePassword(found.encodedpassword)
        return {login: found.login, password: decoded}
      }
    }
    return null
  }

  /**
   * REST api call to log on server.
   * @param {string} login
   * @param {string} password
   * @returns Login status with reusable credential
   */
  async login (login, password) {
    AuthStore().ClearAuthInfos()
    const res = await AxiosCallPost('lynxapi/user/login', {login, password})
    if (res && res.result && res.result.credential) {
      LastInfoStore().NotifyInfo('Connected')
      AuthStore().SetAuthInfos(res.result)
      return true
    } else {
      if (res && res.error === true) {
        LastErrorStore().NotifyError('Can\'t log on: Server connection error')
      } else {
        LastErrorStore().NotifyError('Invalid login/password')
      }
    }
    return false
  }
}
